module.exports = __webpack_public_path__ + "img/T4-D-rc_18.efdf62ce.png";